import { render, staticRenderFns } from "./UseItemButton.vue?vue&type=template&id=7165595d&scoped=true"
import script from "./UseItemButton.vue?vue&type=script&lang=js"
export * from "./UseItemButton.vue?vue&type=script&lang=js"
import style0 from "./UseItemButton.vue?vue&type=style&index=0&id=7165595d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7165595d",
  null
  
)

export default component.exports